import { render, staticRenderFns } from "./ComponentScore.vue?vue&type=template&id=071de86a&"
import script from "./ComponentScore.vue?vue&type=script&lang=js&"
export * from "./ComponentScore.vue?vue&type=script&lang=js&"
import style0 from "./ComponentScore.vue?vue&type=style&index=0&id=071de86a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports